export const GET_TASKS_REQUEST='GET_TASKS_REQUEST'
export const GET_TASKS_SUCCESS='GET_TASKS_SUCCESS'
export const GET_TASKS_FAILURE='GET_TASKS_FAILURE'
export const ADD_TASK_REQUEST='ADD_TASK_REQUEST'
export const ADD_TASK_SUCCESS='ADD_TASK_SUCCESS'
export const ADD_TASK_FAILURE='ADD_TASK_FAILURE'
export const ADD_LABEL = "ADD_LABEL";